// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-aboutme-js": () => import("./../../../src/pages/aboutme.js" /* webpackChunkName: "component---src-pages-aboutme-js" */),
  "component---src-pages-anime-list-mdx": () => import("./../../../src/pages/anime_list.mdx" /* webpackChunkName: "component---src-pages-anime-list-mdx" */),
  "component---src-pages-blogposts-js": () => import("./../../../src/pages/blogposts.js" /* webpackChunkName: "component---src-pages-blogposts-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-manga-list-mdx": () => import("./../../../src/pages/manga_list.mdx" /* webpackChunkName: "component---src-pages-manga-list-mdx" */),
  "component---src-templates-blog-template-js": () => import("./../../../src/templates/blogTemplate.js" /* webpackChunkName: "component---src-templates-blog-template-js" */)
}

